import React, { Component } from "react";
import NavBar from "../../Components/NavBar/NavBar";
import AuthCheck from "../../Components/Utils/AuthCheck";
import Loader from "react-loader-spinner";
import PageRoute from "../../Components/Utils/PageRoutes";
import { apiUrl } from "../../Components/Utils/Constants";

export default class AdminHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      doctors: [],
      loading: true,
    };
  }

  componentDidMount() {
    AuthCheck(this.props);
    fetch(`${apiUrl}/admin/getdoctors`)
      .then((response) => response.json())
      .then((response) => {
        this.setState({
          doctors: response,
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
        });
      });
    // const {s
    //   history
    // } = this.props;
    // history.push('/admin/login')
  }

  viewLiscence = (doctor) => {
    const route = PageRoute.home + "/" + doctor.id;

    // this.props.history.push(route);
    this.props.history.push({
      pathname: route,
      state: {
        doctor,
      },
    });
  };

  render() {
    document.title = "Review Application | Xtendliving";
    const { loading, doctors } = this.state;

    const filteredDoctor = doctors.filter((doctor) => {
      return doctor.verified === 0;
    });

    const tableRow = filteredDoctor.length ? (
      doctors.map((doctor, index) => {
        return (
          <tr key={index + 1}>
            <td>{index + 1}</td>
            <td>{doctor.firstname}</td>
            <td>{doctor.lastname}</td>
            <td>{doctor.department}</td>
            <td>{doctor.phonenumber}</td>
            <td>
              <button
                key={1}
                className="btn black"
                onClick={() => this.viewLiscence(doctor)}
              >
                liscence
              </button>
            </td>
          </tr>
        );
      })
    ) : (
      <tr className="center">
        <td colSpan="6">No New Application</td>
      </tr>
    );

    const table = (
      <table className="responsive-table highlight">
        <thead>
          <tr>
            <th>S/N</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Department</th>
            <th>Phone Number</th>
            <th></th>
          </tr>
        </thead>

        <tbody>{tableRow}</tbody>
      </table>
    );

    return (
      <div>
        <NavBar loggedIn={true} />
        <div className="container center">
          <h4>New Doctor Applications</h4>
          <div>
            {loading ? (
              <Loader type="ThreeDots" color="#000000" height={50} width={50} />
            ) : (
              table
            )}
          </div>
        </div>
      </div>
    );
  }
}
